import type { BulkParticipant } from "@pulse/api/participantApi";
import { useFieldContext } from "../../form-context";
import { useParticipantSearch } from "../../hooks";
import { useTranslation } from "react-i18next";

export function ParticipantSelectorExternal({ email }: { email: string }) {
    const field = useFieldContext<BulkParticipant[]>();
    const { inputRef } = useParticipantSearch();
    const { t } = useTranslation();
    const handleAddParticipant = (email: string) => {
        const currentParticipants = field.state.value || [];
        if (currentParticipants.find((p) => p.isExternal && p.email === email)) return;
        field.setValue([...currentParticipants, { email, isExternal: true }]);
        if (inputRef.current) {
            inputRef.current.value = "";
            inputRef.current.focus();
        }
    };

    return (
        <div className="px-4">
            <div className="text-on-container/70 mb-2">
                {t("userSelector.userOutsideOrganization")}
            </div>
            <button
                type="button"
                onClick={() => handleAddParticipant(email)}
                className="flex w-full items-center  px-4 py-2  cursor-pointer hover:bg-secondary/50"
            >
                <div className="flex items-center space-x-3 w-full font-bold">
                    <div className="w-8 h-8 bg-secondary rounded-full text-lg font-normal">
                        {email[0]}
                    </div>
                    <div className="ml-3 text-left">
                        <p>{email}</p>
                    </div>
                </div>
            </button>
        </div>
    );
}
